import {FC} from 'react';
import {IUseLiveKitResult} from 'core';
import {EllipseButton} from 'ui-kit';

interface IProps {
  lk: IUseLiveKitResult;
  isDisabled?: boolean;
}

export const StartVoiceButton: FC<IProps> = ({lk, isDisabled}) => (
  <EllipseButton
    icon={'Microphone'}
    size={'normal'}
    iconSize={'s32'}
    variant={'transparent'}
    isDisabled={isDisabled || lk.isPending || lk.isError}
    onClick={lk.connect}
  />
);
